import CandidateProfileRtw from './CandidateProfileRtw.component';

export default CandidateProfileRtw;